var width = jQuery(window).width();

$(document).on("click", "#kg_nav li > a", function(event) {

    if ((!$(event.target).is("a")) && (!$(event.target).hasClass("kg_open_menu"))) {
        return;
    }
    $('.kg-header-overlay').addClass('kg-active-overlay');
    if (($(this).closest('li').find('.kg-menu').length >= 1) || ($(this).closest('li').find('.kg-submenu ').length >= 1)) {
        event.preventDefault();
        $('html').addClass('kg_navigation_active');
        (width < 991 && document.getElementById('kg-side-navigation').scrollIntoView());
        if ($(this).closest('li').hasClass("nav_active")) {
            $(this).closest('li').removeClass('nav_active');
            $('.kg-nav-item-back').remove();
        } else {
            var cat_name = $.trim(jQuery(this).text());
            jQuery(this).closest('li').find('.kg-sub-child-group:first').prepend('<div class="kg-nav-item-back"><span class="kg-nav-back-button"><img src="https://cdn.shopify.com/s/files/1/0267/5100/8962/files/LeftArrow.svg?v=1694755630" class="kg_bck_menu"></span><h3 class="kg-nav-item-title">' + cat_name + '</h3><span class="kg-nav-close-button"><img src="https://cdn.shopify.com/s/files/1/0267/5100/8962/files/Cross.svg?v=1694755630"></span></div>');
            $('#kg_nav li:not(.kg-side-navigation)').not($(this).parents('.nav_active')).removeClass('nav_active');
            $(this).closest('li').addClass('nav_active');
        }
    }
});
$(document).on("click", ".header__mobile-nav-toggle", function(event) {
    //$('.kg-nav-item-back').remove();
    $('html').toggleClass('kg_navigation_active');
    $('.kg-side-navigation').toggleClass('nav_active');
    $('#kg-nav-menu').toggleClass('kg_nav_active');
    $('.kg-header-overlay').toggleClass('kg-active-overlay');
    $('.kg-side-navigation').prepend('<span class="kg-top-browse">Browse<span class="kg-nav-close-button"><img src="https://cdn.shopify.com/s/files/1/0267/5100/8962/files/Cross.svg?v=1694755630" ></span></span>');
});

jQuery(document).on("click", ".kg-nav-item-back .kg-nav-back-button", function(e) {
    e.preventDefault();
    jQuery(this).closest('li').removeClass('nav_active');
    jQuery(this).parent().remove();
});

$(document).on("click", ".kg-menu-close-button,.kg-nav-close-button", function(e) {
    $('html').removeClass('kg_navigation_active');
    $('#kg-nav-menu').removeClass('kg_nav_active');
    $('.kg-side-navigation').removeClass('nav_active');
    $('#kg_nav li').removeClass('nav_active');
    $('.kg-nav-item-back').remove();
    $('.kg-top-browse').remove();
    $('.kg-header-overlay').removeClass('kg-active-overlay');
    $('.kg-side-navigation .nav_link:first .kg-nav-close-button').remove();
});

var width = jQuery(window).width();
if (width > 991) {
    $(document).on("click", "html", function(e) {
        if ((!$(e.target).parents('.nav_active').length)) {
            $('html').removeClass('kg_navigation_active');
            $('#kg_nav li').removeClass('nav_active');
            $('.kg-nav-item-back').remove();
            $('.kg-header-overlay').removeClass('kg-active-overlay');
        }
    });
} else {
    $(document).on("click", "html", function(e) {
        if ($(e.target).parents('.header__mobile-nav').length) {} else if ($(e.target).parents('.nav_active').length) {} else if ($(e.target).parents('.kg-nav-back-button').length) {} else {
            $('html').removeClass('kg_navigation_active');
            $('#kg-nav-menu').removeClass('kg_nav_active');
            $('.kg-side-navigation').removeClass('nav_active');
            $('#kg_nav li').removeClass('nav_active');
            $('.kg-nav-item-back').remove();
            $('.kg-top-browse').remove();
            $('.kg-header-overlay').removeClass('kg-active-overlay');
            $('.kg-side-navigation .nav_link:first .kg-nav-close-button').remove();
        }
    });
}

$(window).resize(function() {
    menu_show_more();
});

function menu_show_more() {
    var maxItemsToShow = 13;

    if (window.matchMedia("(max-width: 1880px)").matches) {
        maxItemsToShow = 11;
    }
    if (window.matchMedia("(max-width: 1626px)").matches) {
        maxItemsToShow = 10;
    }
    if (window.matchMedia("(max-width: px)").matches) {
        maxItemsToShow = 10;
    }
    if (window.matchMedia("(max-width: 1395px)").matches) {
        maxItemsToShow = 9;
    }
    if (window.matchMedia("(max-width: 1275px)").matches) {
        maxItemsToShow = 8;
    }
    if (window.matchMedia("(max-width: 1060px)").matches) {
        maxItemsToShow = 7;
    }
    $("#mobileshow").hide();
    $('.kg-nav-bar-linklist li.kg-nav-bar-item').each(function(index) {
        if (index != 0)
            $(this).show();
    });

    console.log(maxItemsToShow,'maxItemsToShowmaxItemsToShowmaxItemsToShow')
    $('.kg-nav-bar-linklist .more_less').remove();
    if (maxItemsToShow <= 13) {
        $("#mobileshow").show();
        $('.kg-nav-bar-linklist').each(function() {
            $(this).find('li.kg-nav-bar-item:gt(' + (maxItemsToShow - 1) + ')').hide();
        });

    }


}
$(document).ready(function() {
    menu_show_more();
});

if (window.matchMedia("(max-width: 767px)").matches) {
    jQuery(function() {
        var maxHeight = 0;
        jQuery('.kg-collection-item__title').each(function(index) {
            if (jQuery(this).height() > maxHeight) {
                maxHeight = jQuery(this).height();
            }
        });
        jQuery('.kg-collection-item__title').height(maxHeight);
    });
}
$(document).ready(function() {
//     // Function to toggle "Read More" and "Read Less" on click
//     $('.read-more-trigger').click(function() {
//         var content = $('.read-more-content');
//         content.toggleClass('read-more-show');
//         if (content.hasClass('read-more-show')) {
//             content.css('max-height', content[0].scrollHeight + 'px');
//             $(this).text('Read Less');
//         } else {
//             content.css('max-height', '6em'); // Adjust this value based on your content
//             $(this).text('Read More');
//         }
//     });

    jQuery('.kg-accordian-item h2').on('click', function() {
        if (jQuery(this).hasClass('active')) {
            jQuery(this).siblings('.elementor-tab-content').slideUp();
            jQuery(this).removeClass('active');
        } else {
            jQuery('.elementor-tab-content').slideUp();
            jQuery('.kg-accordian-item h2').removeClass('active');
            jQuery(this).siblings('.elementor-tab-content').slideToggle();
            jQuery(this).toggleClass('active');
        }
    });

});


// $(document).ready(function() {
//     var price_type_new = Cookies.get('price_type_new');
//   if (typeof price_type_new === 'undefined') {
//         price_type_new = 'Excl';
//     }
//     if (price_type_new === 'Incl') {
//         $('.kg-gst-switch-toggle .kg-gst-switch-input').prop("checked", true);
//         $('.kg-excluding-price').show();
//         $('.kg-including-price').hide();
//     } else if (price_type_new === 'Excl') {
//         $('.kg-gst-switch-toggle .kg-gst-switch-input').prop("checked", false);
//         $('.kg-excluding-price').hide();
//         $('.kg-including-price').show();
//     }
// });
document.addEventListener("theme:loading:end", function (e) {
   gstToggle('cart');
});


$(document).ready(function() {
   gstToggle('');
});

function gstToggle(pageTemplate){
     var price_type = Cookies.get('price_type');
     if (typeof price_type === 'undefined') {
        price_type = 'Excl';
    }
    if (price_type === 'Incl') {
        $('.kg-gst-switch-toggle .kg-gst-switch-input').prop("checked", true);
       
        if(window.template == 'product'){
            $('.kg-excluding-price').css({opacity: 0,position: 'absolute'});
            $('.kg-including-price').css({opacity: 1,position: 'relative'});
            //$('.kg-excluding-price').css('opacity', 0);
            //$('.kg-including-price').css('opacity', 1);
        }else{
            if(pageTemplate){
                    setTimeout(function () {
                         $('.kg-excluding-price').hide();
                         $('.kg-including-price').show();
                    }, 500);
            }
        
            $('.kg-excluding-price').hide();
            $('.kg-including-price').show();
        }

        

    } else if (price_type === 'Excl') {
        $('.kg-gst-switch-toggle .kg-gst-switch-input').prop("checked", false);

         if(window.template == 'product'){
             $('.kg-excluding-price').css({opacity: 1,position: 'relative'});
            $('.kg-including-price').css({opacity: 0, position: 'absolute'});

        //    $('.kg-excluding-price').css('opacity', 1);
        //     $('.kg-including-price').css('opacity', 0);
        }else{
            if(pageTemplate){
                    setTimeout(function () {
                        $('.kg-excluding-price').show();
                        $('.kg-including-price').hide();
                    }, 500);
            }
            $('.kg-excluding-price').show();
            $('.kg-including-price').hide();
        }
        
    }
}
    $(document).on("change", ".kg-gst-switch-toggle .kg-gst-switch-input", function() {
    if ($(this).is(':checked') == true) {
        Cookies.set('price_type', 'Incl');
    } else {
        Cookies.set('price_type', 'Excl');
    }
});

$(document).on("click", ".kg-gst-switch-toggle .kg-gst-switch-input", function() {
    if (!this.checked) {
        $('.kg-gst-switch-toggle .kg-gst-switch-input').prop("checked", false);

          if(window.template == 'product'){
            // $('.kg-excluding-price').css('opacity', 1);
            // $('.kg-including-price').css('opacity', 0);
             $('.kg-excluding-price').css({opacity: 1,position: 'relative'});
             $('.kg-including-price').css({opacity: 0,position: 'absolute'});
        }else{
            $('.kg-excluding-price').show();
            $('.kg-including-price').hide();
        }

    } else {
        $('.kg-gst-switch-toggle .kg-gst-switch-input').prop("checked", true);

         if(window.template == 'product'){
            $('.kg-excluding-price').css({opacity: 0,position: 'absolute'});
             $('.kg-including-price').css({opacity: 1,position: 'relative'});
            // $('.kg-excluding-price').css('opacity', 0);
            // $('.kg-including-price').css('opacity', 1);
        }else{
            $('.kg-excluding-price').hide();
            $('.kg-including-price').show();
        }

    }
});
$(document).on('click', '#myModal .close_modal', function() {
    $("#myModal").hide();
});

$(document).on('click', '.button_quote_click', function() {
 if (product_sku == '') {
        product_sku = $(this).attr('title');
    }
    // showLoader();
    $.ajax({
        url: "https://laravel.restaurantequipment.com.au/api/quotes?is_modal=1",
        type: "GET",
        data: {
            cart_token: cart_token,
            product_sku: product_sku
        },
        dataType: "json",
        contentType: "application/json;",
        success: function(data) {
            // hideLoader();
            if (data.success == true) {
                $('#modal_html').html(data.html);
                // console.log(modal, "modal modal");
                $("#myModal").show();
                $('body').find('#product_sku').trigger('change');

            }
        },
        error: function(err) {
            //hideLoader();
        }
    });
})


var uuid = function() {
    var u = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
        function(c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    return u;
}

var getDeviceId = function() {
    var current = window.localStorage.getItem("_DEVICEID_")

    if (current) return current;
    var id = uuid();
    window.localStorage.setItem("_DEVICEID_", id);
    return id;
}
var cart_token = getDeviceId();

const placeholderTexts = [
    "Search 10,000+ Products",
    "Search Commercial Fridges",
    "Search Commercial Freezers",
    "Search Ice Machines",
    "Search Deep Fryers",
    "Search Cooking Equipment",
    "Search Commercial Ovens",
    "Search Commercial Dishwashers"
];

let index = 0;

function rotatePlaceholder() {
    const searchInput = $('.search-bar__input');
    searchInput.attr('placeholder', placeholderTexts[index]);
    index = (index + 1) % placeholderTexts.length;
}
setInterval(rotatePlaceholder, 1000);

jQuery("#kg-enquire-now").on('click', function() {
    jQuery('html, body').scrollTop(jQuery("#kg-contact-form").offset().top - 170);
});
document.addEventListener("theme:minicart:end", function (e) {
    toggleMiniCartPrices()
});
function toggleMiniCartPrices() {
  var price_type = Cookies.get('price_type') || 'Excl';

  if (price_type === 'Incl') {
    document.querySelectorAll('.kg-including-cart-price').forEach(el => el.style.display = 'block');
    document.querySelectorAll('.kg-excluding-cart-price').forEach(el => el.style.display = 'none');
  } else {
    document.querySelectorAll('.kg-excluding-cart-price').forEach(el => el.style.display = 'block');
    document.querySelectorAll('.kg-including-cart-price').forEach(el => el.style.display = 'none');
  }
}

// Initial run
document.addEventListener('DOMContentLoaded', toggleMiniCartPrices);

// Watch for mini-cart AJAX updates
const observer = new MutationObserver(toggleMiniCartPrices);
observer.observe(document.body, { childList: true, subtree: true });


(function ($) {
    const GST_RATE = 0.15;
    const BASE_PRICE_DATA_ATTR = 'data-original-price';
    let basePricesStored = false;
    let isProcessingAjax = false;

    function formatPrice(val) {
        return '$' + val.toFixed(2);
    }

    function extractPriceFromText(text) {
        const match = text.match(/\$([\d,.]+)/);
        return match ? parseFloat(match[1].replace(/,/g, '')) : null;
    }

    function storeOriginalPrices() {
        if (basePricesStored && !isProcessingAjax) return;
        
        console.log('Storing original GST-excluded prices...');
        
        const isIncluding = $('.kg-gst-switch-toggle .kg-gst-switch-input').prop('checked');
        
        $('.kg-price, .shipping_cost, #product_html [id^="sku-"], #product_html td').each(function () {
            const $el = $(this);
            const text = $el.text().trim();
            const price = extractPriceFromText(text);
            
            if (!price) return;
            
            let originalPrice;
            if (isIncluding) {
                originalPrice = price / (1 + GST_RATE);
            } else {
                originalPrice = price;
            }
            
            $el.attr(BASE_PRICE_DATA_ATTR, originalPrice.toFixed(2));
            console.log('Stored original price:', originalPrice, 'from displayed:', price);
        });
        
        basePricesStored = true;
        isProcessingAjax = false;
    }

    function storeNewElementPrices() {
        const isIncluding = $('.kg-gst-switch-toggle .kg-gst-switch-input').prop('checked');
        
        $('.kg-price, .shipping_cost, #product_html [id^="sku-"], #product_html td').each(function () {
            const $el = $(this);
            
            if ($el.attr(BASE_PRICE_DATA_ATTR)) return;
            
            const text = $el.text().trim();
            const price = extractPriceFromText(text);
            
            if (!price) return;
            
            let originalPrice;
            if (isIncluding) {
                originalPrice = price / (1 + GST_RATE);
            } else {
                originalPrice = price;
            }
            
            $el.attr(BASE_PRICE_DATA_ATTR, originalPrice.toFixed(2));
        });
    }

    function applyGST(includeGST) {
        console.log('Applying GST - includeGST:', includeGST);
        
        $('[' + BASE_PRICE_DATA_ATTR + ']').each(function () {
            const $el = $(this);
            const originalPrice = parseFloat($el.attr(BASE_PRICE_DATA_ATTR));
            
            if (isNaN(originalPrice)) return;
            
            let finalPrice;
            if (includeGST) {
                finalPrice = originalPrice * (1 + GST_RATE);
            } else {
                finalPrice = originalPrice;
            }
            
            $el.html(function(i, html) {
                return html.replace(/\$[\d,.]+/, formatPrice(finalPrice));
            });
        });
    }

    function syncWithToggle() {
        storeNewElementPrices();
        
        const isIncluding = $('.kg-gst-switch-toggle .kg-gst-switch-input').prop('checked');
        applyGST(isIncluding);
    }

    $(document).ready(function() {
        
        $('.kg-gst-switch-toggle .kg-gst-switch-input').prop('checked', false);
        
        setTimeout(function() {
            storeOriginalPrices();
            applyGST(false); 
        }, 500);
    });

    $(document).ajaxComplete(function(event, xhr, settings) {
        if (settings.url && settings.url.includes('/shipping-estimator') || 
            settings.data && settings.data.includes('postcode')) {
            
            isProcessingAjax = true;
            
            setTimeout(function() {
                $('.kg-price, .shipping_cost, #product_html [id^="sku-"], #product_html td').each(function () {
                    const $el = $(this);
                    const text = $el.text().trim();
                    const price = extractPriceFromText(text);
                    
                    if (!price) return;
                    
                    $el.attr(BASE_PRICE_DATA_ATTR, price.toFixed(2));
                });
                
                const isIncluding = $('.kg-gst-switch-toggle .kg-gst-switch-input').prop('checked');
                applyGST(isIncluding);
                
                isProcessingAjax = false;
            }, 300);
        }
    });

    const observer = new MutationObserver(function(mutations) {
        let hasNewContent = false;
        
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length > 0) {
                hasNewContent = true;
            }
        });
        
        if (hasNewContent && !isProcessingAjax) {
            console.log('New content detected (non-AJAX)...');
            setTimeout(function() {
                storeNewElementPrices();
                
                const isIncluding = $('.kg-gst-switch-toggle .kg-gst-switch-input').prop('checked');
                applyGST(isIncluding);
            }, 200);
        }
    });

    const containers = ['product_html', 'shipping_message', 'inventory_div'];
    containers.forEach(function(containerId) {
        const container = document.getElementById(containerId);
        if (container) {
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
    });

    $(document).on('change', '.kg-gst-switch-toggle .kg-gst-switch-input', function () {
        
        applyGST(this.checked);
    });

 

    $(document).on('input', '#product_sku_estimator', function() {
        basePricesStored = false;
    });

})(jQuery);